import { pathJoin } from 'src/reducers/routing/utils'

export const createContainerRouteMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  routes: pathJoin(prefix)('route').chain,
  'service-log': pathJoin(prefix)('service-log').chain,
  history: pathJoin(prefix)('history').chain,
  tickets: pathJoin(prefix)('tickets').chain,
  property: pathJoin(prefix)('property').chain,
  invoices: pathJoin(prefix)('invoices').chain,
  'property-group': pathJoin(prefix)('property-group').chain,
  agreements: pathJoin(prefix)('agreements').chain,
  'temporary-changes': pathJoin(prefix)('temporary-changes').chain,
  // PRO-391 (3.5.69): the unit's asset card - identity + movement history
  // + maintenance + condition history in one place, the click-through
  // target from a serialized row (in-storage-tab/table.tsx).
  'stock-activity': pathJoin(prefix)('stock-activity').chain,
})
